import {
  AccidentSource,
  AccidentType,
  VehicleSupplier,
  VideoCaptureStatus,
} from '@/utils/constant';
import CommonForm from '../CommonForm';
import dayjs from 'dayjs';
import PopoverListBtn from '@/views/WarningListView/PopoverListBtn';
import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import { isEmpty } from '@/utils';
import { HttpStatusCode } from '@/fetch/core/constant';
import { request } from '@/fetch/core';
import { FormInstance, message } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Modal } from 'antd';
import { Method } from '@/fetch/core/util';
import { EditFormConfig } from './constant';
import UseGetCommonEnumMap from '@/utils/hooks/UseGetCommonEnumMap';
import { CommonEnumKey } from '@/utils/enum';
import { useNavigate } from 'react-router-dom';
const { confirm } = Modal;

type AccidentProps = {
  handleClickAccidentAddBtn: AnyFunc;
  handleClickRepairAddBtn: AnyFunc;
  accidentList: any[];
  vehicleName: string;
  stationName: string;
  vehicleSupplier: string;
};

const AccidentItem = (props: {
  stationName: string;
  vehicleName: string;
  createUser: string;
  createTime: number;
  accidentTime: number;
  accidentType: AccidentType;
  accidentSource: AccidentSource;
  accidentDesc: string;
  accidentNo: any;
  jiraNo: any;
  shadowEventId: string;
  snapshotAttachmentUrlList: any[];
  videoCaptureStatus: string;
  bugCode: string;
  technicalSupportAccidentLevel: string;
  vehicleSupplier: string;
  responsible: string; // 无人车有无责任
}) => {
  const formInstance = useRef<any>(null);
  const navigate = useNavigate();
  const [formConfig, setFormConfig] = useState<FormConfig>(EditFormConfig); // 表单实例
  const { enumMap } = UseGetCommonEnumMap([
    CommonEnumKey.NEW_ACCIDENT_LEVEL_ENUM,
    CommonEnumKey.ACCIDENT_RESPONSIBLE_ENUM,
  ]); // 公共枚举值（“事故等级”和“有无责任”的下拉框数据）

  const showSendCardConfirm = () => {
    confirm({
      centered: true,
      title: '提示',
      icon: (
        <ExclamationCircleFilled
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      ),
      content: '确定要“提交”并报备到“事故群”吗?',
      okText: '确定报备',
      style: {
        border: '1px solid #FFF',
      },
      onOk() {
        onSubmit(true);
      },
      onCancel() {},
    });
  };
  const onSubmit = async (sendCard: any) => {
    if (formInstance.current) {
      const fieldsValue = await formInstance.current.validateFields();
      const saveValue: any = {
        technicalSupportDescription: fieldsValue.accidentDesc,
        responsible: fieldsValue.responsible
          ? fieldsValue.responsible
          : props.responsible,
        technicalSupportAccidentLevel: fieldsValue.technicalSupportAccidentLevel
          ? fieldsValue.technicalSupportAccidentLevel
          : props.technicalSupportAccidentLevel,
        accidentNo: props.accidentNo,
        sendCard: sendCard,
      };
      const requestData = {
        path: '/monitor/web/accident/technical_support_edit_accident',
        method: 'POST',
        body: saveValue,
      };
      request(requestData)
        .then((res) => {
          if (res.code === HttpStatusCode.Success) {
            message.success('修改事故信息成功！').then(() => {
              const searchParams = new URLSearchParams({
                activeTab: 'menuAccidentManagement',
              });
              if (!isEmpty(props.accidentNo)) {
                searchParams.set('accidentNo', String(props.accidentNo));
              }
              navigate(`/app/accidentmanage?${searchParams.toString()}`);
            });
          } else {
            message.error(res.message || '修改事故信息失败！');
          }
        })
        .catch((err) => {
          message.error(err);
        });
    }
  };
  const handleShare = async (value: any) => {
    const requestParam: RequestOptions = {
      path: '/monitor/web/accident/get_accident_basic_info',
      method: Method.POST,
      body: {
        accidentNo: value.accidentNo,
      },
    };
    const res: any = await request(requestParam);
    if (res.code == HttpStatusCode.Success) {
      getVideoUrl(res.data.shadowEventId, res.data);
    } else {
      message.error(res.message || '接口请求报错');
    }
  };

  const getVideoUrl = async (id: any, value: any) => {
    const requestParam: RequestOptions = {
      method: 'POST',
      path: '/shadow/web/event/link/view',
      body: { type: 'event', id: id },
    };
    const resp: any = await request(requestParam);
    if (resp.code === HttpStatusCode.Success) {
      if (window.navigator.clipboard) {
        window.navigator.clipboard.writeText(
          `事故编号${value.accidentNo}|${
            value.accidentReportTime
              ? value.accidentReportTime
              : '事故发生时间待排查'
          }|${value.vehicleName}|${value.stationName}|${value.accidentDesc}|${
            value.jiraNo || value.bugCode || '未提报缺陷'
          }|${value.bugTitle || '无缺陷标题'}\n 监控事故管理链接:https://${
            process.env.JDX_APP_JDX_MONITOR
          }/app/warnings \n事故视频查看:${resp.data.videoUrl} `
        );
        message.success('链接复制成功');
      }
    } else {
      message.error(resp.message || '接口请求报错');
    }
  };

  /**
   * 拉取下拉框数据后重新设置表单配置
   * @param {FieldItem} field
   * @return {*}  {FieldItem}
   */
  const updateFieldItem = (field: FieldItem): FieldItem => {
    const newField: FieldItem = { ...field };
    switch (newField.fieldName) {
      case 'snapshotAttachmentUrlList':
        newField.defaultFileList = props.snapshotAttachmentUrlList?.map(
          (i: any) => ({
            uid: i.fileKey,
            type: i.type,
            url: i.url,
            name: i.name,
          })
        );
        newField.placeholder = props.videoCaptureStatus
          ? VideoCaptureStatus.get(props.videoCaptureStatus)
          : '--';
        break;
      case 'technicalSupportAccidentLevel':
        newField.valueToLabelCondition = props.bugCode ? true : false;
        newField.valueToLabelEnumGroupKey = props.bugCode
          ? CommonEnumKey.NEW_ACCIDENT_LEVEL_ENUM
          : undefined;
        newField.data = enumMap[CommonEnumKey.NEW_ACCIDENT_LEVEL_ENUM];
        break;
      case 'accidentTime':
        newField.disabled =
          props.accidentSource === AccidentSource.VEHICLE_REPORT;
        break;
      case 'responsible':
        newField.valueToLabelCondition = props.bugCode ? true : false;
        newField.valueToLabelEnumGroupKey = props.bugCode
          ? CommonEnumKey.ACCIDENT_RESPONSIBLE_ENUM
          : undefined;
        newField.data = enumMap[CommonEnumKey.ACCIDENT_RESPONSIBLE_ENUM];
        break;
      default:
        break;
    }
    return newField;
  };

  /**
   * 拉取下拉框数据后重新设置表单配置
   * - 格式化附件照片
   * - 添加‘有无责任’与‘事故等级’的下拉框数据
   * - 添加‘事故时间’的禁用状态
   */
  useEffect(() => {
    setFormConfig((prev) => {
      if (!prev) return prev;
      const newData = (prev.data || []).map((f: FieldItem) =>
        updateFieldItem(f)
      );
      return {
        ...prev,
        data: newData,
      };
    });
  }, [
    enumMap,
    props.videoCaptureStatus,
    props.bugCode,
    props.accidentSource,
    props.snapshotAttachmentUrlList,
  ]);

  return (
    <div className="accident-item">
      <div className="accident-item_head">
        <i className="create-time">
          {props.createTime ? dayjs(props.createTime).format('HH:mm:ss') : '--'}
        </i>
        <div className="row-item">
          <i>创建人：{props.createUser}</i>
        </div>
        <i
          className="share-btn"
          onClick={() => {
            handleShare(props);
          }}
        ></i>
      </div>
      <div className="accident-info">
        <CommonForm
          className="accident-item_form"
          config={formConfig}
          labelAlign="left"
          getFormInstance={(formRef: FormInstance) => {
            formInstance.current = formRef;
          }}
          layout={'horizontal'}
          defaultValue={{
            technicalSupportAccidentLevel:
              props.technicalSupportAccidentLevel ?? null,
            responsible: props.responsible ?? null,
            accidentTime: props.accidentTime ? dayjs(props.accidentTime) : null,
            accidentDesc: props.accidentDesc ?? null,
          }}
        />
      </div>
      <div className="operation-btn">
        <PopoverListBtn
          id={props.shadowEventId}
          btnText="查看详情"
          type="event"
        ></PopoverListBtn>
        <span className="row-btn" onClick={() => onSubmit(false)}>
          提交
        </span>
        <span className="row-btn" onClick={() => showSendCardConfirm()}>
          提交并报备
        </span>
      </div>
    </div>
  );
};

const AccidentManagement = (props: AccidentProps) => {
  const {
    handleClickAccidentAddBtn,
    handleClickRepairAddBtn,
    accidentList,
    vehicleName,
    stationName,
    vehicleSupplier,
  } = props;
  return (
    <div className="accident-wrapper">
      {!isEmpty(accidentList) ? (
        <div className="accident-list">
          {accidentList.map((item, index) => (
            <AccidentItem
              {...item}
              technicalSupportAccidentLevel={item.accidentLevel}
              bugCode={item.bugCode}
              snapshotAttachmentUrlList={item.snapshotAttachmentUrlList}
              videoCaptureStatus={item.videoCaptureStatus}
              vehicleName={vehicleName}
              stationName={stationName}
              key={item.accidentNo}
              vehicleSupplier={vehicleSupplier}
              responsible={item.responsible}
            />
          ))}
        </div>
      ) : (
        <div className="empty-text">今日无事故创建</div>
      )}
      <div className="btns-container">
        <div className="btn" onClick={handleClickAccidentAddBtn}>
          创建事故 <i className="add-icon">+</i>
        </div>
        <div className="btn" onClick={handleClickRepairAddBtn}>
          创建维修单 <i className="add-icon">+</i>
        </div>
      </div>
    </div>
  );
};

export default React.memo(AccidentManagement);
